import { hotRank, hotTags } from "@/mocks/gossip";

function rankBadge(rank: number) {
  if (rank === 1) return "bg-primary-500 text-background-50";
  if (rank === 2) return "bg-accent-500 text-foreground-950";
  if (rank === 3) return "bg-secondary-500 text-background-50";
  return "bg-background-200 text-foreground-500";
}

export default function RankPanel() {
  return (
    <aside className="space-y-5">
      {/* 热度榜 */}
      <div className="rounded-lg border border-background-200 bg-background-100">
        <div className="flex items-center justify-between border-b border-background-200 px-4 py-3 md:px-5">
          <h3 className="flex items-center gap-2 font-heading text-lg font-black text-foreground-950">
            <i className="ri-fire-fill text-xl text-primary-600"></i>吃瓜热度榜
          </h3>
          <span className="text-[11px] text-foreground-500">每 10 分钟刷新</span>
        </div>
        <ol className="divide-y divide-background-200">
          {hotRank.map((r) => (
            <li key={r.rank}>
              <a href="#floor" className="group flex items-start gap-3 px-4 py-3 transition hover:bg-background-50 md:px-5">
                <span className={"flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold " + rankBadge(r.rank)}>
                  {r.rank}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 group-hover:text-primary-700">
                    {r.title}
                  </span>
                  <span className="mt-1 flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
                    <span className="whitespace-nowrap rounded bg-background-200 px-1.5 py-0.5">{r.tag}</span>
                    <span className="inline-flex items-center gap-1"><i className="ri-stack-fill text-primary-600"></i>{r.floor} 楼</span>
                    <span className="inline-flex items-center gap-1 text-accent-700"><i className="ri-fire-line"></i>{r.heat}</span>
                  </span>
                </span>
                <span className="shrink-0 text-[11px] text-secondary-700">{r.delta}</span>
              </a>
            </li>
          ))}
        </ol>
        <a href="#feed" className="flex items-center justify-center gap-1 border-t border-background-200 py-2.5 text-xs text-foreground-600 hover:text-primary-700">
          查看完整榜单<i className="ri-arrow-down-line"></i>
        </a>
      </div>

      {/* 热词 */}
      <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
        <h3 className="mb-3 font-heading text-base font-black text-foreground-950">本周热议词</h3>
        <div className="flex flex-wrap gap-2">
          {hotTags.map((t) => (
            <a
              key={t}
              href="#feed"
              className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900 transition hover:bg-secondary-500 hover:text-background-50"
            >
              #{t}
            </a>
          ))}
        </div>
      </div>

      {/* 蹲帖提醒 */}
      <div className="relative overflow-hidden rounded-lg bg-gradient-to-br from-foreground-950 to-foreground-800 p-5">
        <i className="ri-notification-3-line absolute -right-3 -top-3 text-7xl text-white/10"></i>
        <h3 className="relative flex items-center gap-2 font-heading text-lg font-black text-white">
          <i className="ri-stack-line text-primary-400"></i>蹲帖提醒
        </h3>
        <p className="relative mt-2 text-sm leading-relaxed text-white/75">
          关注中的瓜一旦有新楼层进展，更新随时顶上来，第一时间推给你。
        </p>
        <button className="relative mt-4 flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-400">
          <i className="ri-bell-fill mr-1.5"></i>开启楼层跟进提醒
        </button>
      </div>
    </aside>
  );
}